/**
 * This file holds computed state properties
 * Please refer to https://vuex.vuejs.org/guide/getters.html for more information
 */

const getters = {

  /**
   * @function loadAutomatically
   * Checks the web address for the parameter that
   * signals that the CustomCheckerboard modal should open by itself
   * after the page and dependencies have loaded.
   * The parameter will be added on the inbound link of the marketing collateral.
   * For example, a Tweet will contain https://www.vans.com/custom-shoes.html?loadCC=true
   * @returns {Boolean} True to indicate the modal should open as soon as possible.
   */
  loadAutomatically(store, getters, rootState) {
    return rootState.utils.queryParams.loadCC === "true" || rootState.utils.queryParams.canvas;
  },

  /**
   * @function flowId
   * Checks the web address for the parameter that
   * signals that the CustomCheckerboard modal should open by itself
   * after the page and dependencies have loaded.
   * The parameter will be added on the inbound link of the marketing collateral.
   * For example, a Tweet will contain https://www.vans.com/custom-shoes.html?loadCC=true&ccFlow=default
   * @returns {String} CTA id name indicate the button id will should open as soon as possible.
   */
  flowId(store, getters, rootState) {
    return rootState.utils.queryParams.ccFlow;
  },

  getNextUGCComponent(store, getters, rootState) {
    if (!rootState.utils.pdm) return [];
    const { pdm } = rootState.utils;
    const ugcComponents = Object.keys(pdm.components).filter(component => pdm.components[component].hasOwnProperty("ugc"));
    return ugcComponents.filter(item => item != rootState.legacyNavigation.activeComponent)[0];
  },

  isSecondComponentFlow(state, getters, rootState, rootGetters) {
    const secondaryComponent = rootGetters["ugc/getUGCComponentNotActive"];
    const customCheckerboardAlreadyCreated = state.components.hasOwnProperty(secondaryComponent);
    const { useSecondView } = state;
    return secondaryComponent && customCheckerboardAlreadyCreated || useSecondView;
  },
};

export default getters;
